import Request from "../model/Request";
import Response from "../model/Response";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";
import PagedResponse from "../entities/PagedResponse";
import Pagination from "../entities/Pagination";
import TransactionStatus from "../entities/TransactionStatus";
import ArticleTransaction from "../entities/ArticleTransaction";
import ArticleTransactionResponse from "../model/articleTransaction/ArticleTransactionResponse";

export module ArticleTransactionService {
    export async function get(
        entityId?: string,
        page: number = 1,
        pageSize: number = 15,
        from?: number,
        to?: number,
        status?: TransactionStatus,
        articleId?: string,
        transactionType?: string
    ): Promise<Response<PagedResponse<ArticleTransactionResponse>>> {
        const url = Config.get("GET_ARTICLE_TRANSACTION_URL", {page, pageSize, entityId, from, to, status, articleId, transactionType});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const transactionData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (transactionData && paginationData) {
                const data = transactionData.map((t: any) =>
                    new ArticleTransactionResponse(
                        t.id,
                        t.amount,
                        t.articleId,
                        t.articleName,
                        t.direction,
                        t.status,
                        t.createdAt,
                        t.toId,
                        t.toName,
                        t.toType,
                        t.fromId,
                        t.fromName,
                        t.fromType,
                        t.amountFromBefore,
                        t.amountToBefore,
                        t.comment,
                        t.error
                    ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ArticleTransaction>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ArticleTransaction>>(false, undefined, response.error, response.status);
    }

}